export default __webpack_public_path__ + "static/media/blog.99519e48.png";